export const STEPS = {
  REGISTRATION: 'REGISTRATION',
  REGISTRATION_COMPLETED: 'REGISTRATION_COMPLETED',
  DONATIONS: 'DONATIONS',
  BILLING: 'BILLING',
  UPDATE_DATA_MODAL: 'UPDATE_DATA_MODAL',
  COMPLETED: 'COMPLETED',
  SUCCESS_WITH_REDIRECT: 'SUCCESS_WITH_REDIRECT',
  SUCCESS: 'SUCCESS',
};

export const PAGES = {
  [STEPS.REGISTRATION]: STEPS.REGISTRATION,
  [STEPS.DONATIONS]: STEPS.REGISTRATION,
  [STEPS.BILLING]: STEPS.BILLING,
  [STEPS.UPDATE_DATA_MODAL]: STEPS.BILLING,
  [STEPS.SUCCESS]: STEPS.SUCCESS,
  [STEPS.SUCCESS_WITH_REDIRECT]: STEPS.SUCCESS_WITH_REDIRECT,
  [STEPS.COMPLETED]: STEPS.COMPLETED,
};

export const BILLING_TRANSLATION = {
  ADDRESS_1: 'web.networks.events.receipt.billing_location.address_1',
  ADDRESS_2: 'web.networks.events.receipt.billing_location.address_2',
  ADDRESS_3: 'web.networks.events.receipt.billing_location.address_3',
  COUNTRY: 'web.networks.events.receipt.billing_location.country',
  CITY: 'web.networks.events.receipt.billing_location.city',
  STATE: 'web.networks.events.receipt.billing_location.state',
  POSTAL_CODE: 'web.networks.events.receipt.billing_location.postal_code',
};
